export const SOMETHING_WENT_WRONG_ERR_MSG: string = 'Something went wrong. Please try again or Contact Support.';
export const SELECT_REQUIRED_FIELDS: string = 'Please select all the required fields.';
export const REQUEST_SUBMITTED_SUCCESFULLY: string = 'Request has been submitted successfully.';
export const FILE_NOT_SUPPORTED_MSG: string = 'Please upload matching file format: ';
export const FIELD_IS_REQUIRED_ERR_MSG: string = 'This field is required.';